import React, { useState, useMemo, useEffect } from 'react';
import { compileListName } from '@stone/utils/analytics';
import ProductTilesListContext from '@stone/scripts/contexts/ProductTilesListContext';
import ProductShopTheLookPanel from '@stone/components/product/ProductShopTheLookPanel';
import ProductShopTheLookModule from './ProductShopTheLookModule';
import ModalDrawer from '@stone/components/modal/ModalDrawer';
import analytics from '@stone/utils/analytics';
import customEventBus from '@common/scripts/libs/eventBus';
import { useTranslation } from 'react-i18next';
const ProductShopTheLook = (props) => {
    const { t } = useTranslation();
    const { looks } = props;
    const [isShopTheLookOpen, setIsShopTheLookOpen] = useState(false);
    const [activeLook, setActiveLook] = useState(0);
    const [panelCalledByMainModule, setPanelCalledByMainModule] = useState(false);
    const analyticsListName = compileListName('shop the look');
    useEffect(() => {
        analytics.productImpressions({ products: looks, index: 0, isScroll: true, item_list_name: analyticsListName });
        customEventBus.on('shopthelook:quickbuy', onLookClick);
        return () => {
            customEventBus.off('shopthelook:quickbuy', onLookClick);
        };
    }, [looks]);
    const onLookClick = (data) => {
        if (data && typeof data.lookIndex === 'number') {
            const lookIndex = data.lookIndex;
            const lookProduct = looks[lookIndex];
            const analyticsAction = data.fromMainModule ? 'click - shop the look main' : 'click - shop the look info panel';
            analytics.shopTheLookQuickAdd(lookProduct.id, analyticsAction);
            setPanelCalledByMainModule(data.fromMainModule);
            setActiveLook(lookIndex);
            setIsShopTheLookOpen(true);
        }
    };
    /* ADD ANALYTICS CONTEXT */
    const listContextData = useMemo(() => {
        return { analyticsData: { item_list_name: analyticsListName } };
    }, [props.product, panelCalledByMainModule]);
    return (React.createElement(ProductTilesListContext.Provider, { value: listContextData },
        React.createElement(ProductShopTheLookModule, { product: props.product, looks: looks }),
        React.createElement(ModalDrawer, { isOpen: !!isShopTheLookOpen, onRequestClose: () => setIsShopTheLookOpen(false), contentLabel: t('label.shopthelook') },
            React.createElement(ProductShopTheLookPanel, { fromMainModule: panelCalledByMainModule, looks: looks, startingItem: activeLook, onClose: () => setIsShopTheLookOpen(false) }))));
};
export default ProductShopTheLook;
